/** Production context */
import ISBN from "is-isbn";
import memoize from "lodash/memoize";

import { db, firebase } from "astrid-firebase";
import { toDate } from "astrid-web/src/helpers/fnc";

const isbnIsValid = memoize((isbn) => !isbn || ISBN.validate(isbn));

export const getAlerts = ({ id, production }) => {
	const alerts = {};

	// urls
	const infoModal = `/production/${id}/info/edit`;
	const articleTab = `/production/${id}/articles`;
	const audiobookTab = `/production/${id}/audiobook`;

	// title metadata
	if (!production.title) alerts.title = { tab: "info", url: infoModal };
	if (!production.language) alerts.language = { tab: "info", url: infoModal };
	if (!production.author?.length) alerts.author = { tab: "info", url: infoModal };

	const isTranslated =
		production.language && production.languageOriginal && production.language !== production.languageOriginal;
	if (isTranslated && !production.titleOriginal) alerts.titleOriginal = { tab: "info", url: infoModal };
	if (isTranslated && !production.translator?.length) alerts.translator = { tab: "info", url: infoModal };

	if (!production.genre?.length) alerts.genre = { tab: "info", url: infoModal };
	if (!production.synopsis) alerts.synopsis = { tab: "info", url: infoModal };

	if (!production.author?.length) alerts.author = { tab: "info", url: infoModal };

	const hasAudioArticle =
		typeof production.isbn === "string" ||
		production.deliveryParts?.length ||
		production.deliveryCD ||
		production.deliveryMP3CD;

	// article info
	if (!(typeof production.isbn === "string" || production.deliveryEbook || production.deliveryParts))
		alerts.articles = { tab: "articles", url: articleTab };

	if (
		hasAudioArticle &&
		typeof production.productionType === "undefined" &&
		production.producer &&
		production.status === "draft"
	)
		alerts.productionType = { tab: "articles", url: articleTab };

	if (["external", "backlist"].includes(production.productionType) && !production.reader?.length && hasAudioArticle) {
		alerts.reader = { tab: "articles", url: articleTab };
	}

	if (typeof production.isbn === "string" && !(production.isbn && isbnIsValid(production.isbn)))
		alerts.isbn = { tab: "articles", url: articleTab };

	// audiobook production info
	if (hasAudioArticle) {
		if (
			!production.deliveryDate ||
			(production.status === "draft" &&
				production.productionType !== "external" &&
				toDate(production.deliveryDate) < new Date(+Date.now() + 7 * 24 * 60 * 60 * 1000))
		)
			alerts.deliveryDate = { tab: "articles", url: articleTab };

		if (
			!production.script &&
			!production.scriptDate &&
			!["external", "backlist"].includes(production.productionType)
		)
			alerts.script = { tab: "audiobook", url: audiobookTab };
		if (production.scriptDate && !production.pages) alerts.pages = { tab: "audiobook", url: audiobookTab };
	}

	return alerts;
};

//Soft delete
export const deleteProduction = (productionId, uid) => {
	db.collection("productions")
		.doc(productionId)
		.update({
			deleted: firebase.firestore.FieldValue.serverTimestamp(),
			deletedBy: uid,
			updated: firebase.firestore.FieldValue.serverTimestamp(),
		})
		.catch((err) => {
			console.log("Production data update error", err);
		});
};
